(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["contact-shopify-forms-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    const panelRoot = document.querySelector('[data-contact-panel-root]');
    if (!panelRoot) return;

    const copyNode = document.getElementById('ContactSuccessCopy');
    let successCopy = null;

    if (copyNode) {
      try {
        successCopy = JSON.parse(copyNode.textContent);
      } catch (error) {
        successCopy = null;
      }
    }

    const watchedEmbeds = new WeakSet();
    const mobileFieldWidthQuery = window.matchMedia('(max-width: 47.999rem)');
    let fieldWidthSyncFrame = 0;
    let referenceTrackWidth = 0;

    function measureContactFieldTrackWidth() {
      const activeView = panelRoot.querySelector('.contact-panel__view:not([hidden])');

      if (activeView?.dataset.contactPanelView === 'general') {
        const generalField = activeView
          .querySelector('shopify-forms-embed')
          ?.shadowRoot?.querySelector('input[class*="_formInputField_"], textarea[class*="_textArea_"]');
        const fieldWidth = Math.round(generalField?.getBoundingClientRect().width || 0);
        if (fieldWidth > 0) {
          referenceTrackWidth = fieldWidth;
          return fieldWidth;
        }
      }

      if (referenceTrackWidth > 0) return referenceTrackWidth;

      const fieldsShell =
        activeView?.querySelector('.contact-panel__form-fields') ||
        panelRoot.querySelector('[data-contact-panel-view="general"] .contact-panel__form-fields');

      return Math.round(fieldsShell?.clientWidth || 0);
    }

    function syncMobileContactFieldWidth() {
      if (!mobileFieldWidthQuery.matches) {
        panelRoot.querySelectorAll('shopify-forms-embed').forEach((embed) => {
          embed.style.removeProperty('--cervus-contact-field-width');
        });
        return;
      }

      const trackWidth = measureContactFieldTrackWidth();
      if (!trackWidth) return;

      const widthValue = `${trackWidth}px`;
      panelRoot.querySelectorAll('shopify-forms-embed').forEach((embed) => {
        embed.style.setProperty('--cervus-contact-field-width', widthValue);
      });
    }

    function scheduleMobileFieldWidthSync() {
      if (!mobileFieldWidthQuery.matches) return;

      if (fieldWidthSyncFrame) {
        window.cancelAnimationFrame(fieldWidthSyncFrame);
      }

      fieldWidthSyncFrame = window.requestAnimationFrame(() => {
        fieldWidthSyncFrame = 0;
        syncMobileContactFieldWidth();
      });
    }

    function syncSuccessLayout() {
      const body = panelRoot.querySelector('.contact-panel__body');
      if (!body) return;

      const hasSuccess = Array.from(panelRoot.querySelectorAll('shopify-forms-embed')).some((embed) => {
        return embed.shadowRoot && embed.shadowRoot.querySelector('[data-testid="banner-success"]');
      });

      body.classList.toggle('contact-panel__body--success', hasSuccess && panelRoot.classList.contains('is-open'));
    }

    function enhanceSuccessBanner(shadowRoot) {
      if (!successCopy || !shadowRoot) return;

      const banner = shadowRoot.querySelector('[data-testid="banner-success"]');
      if (!banner || banner.dataset.cervusSuccessEnhanced === 'true') return;

      const textBody = banner.querySelector('[class*="_textBody_"]');
      if (!textBody) return;

      textBody.innerHTML = '';
      textBody.classList.add('cervus-success__body');

      successCopy.lines.forEach((line) => {
        const paragraph = document.createElement('p');
        paragraph.className = 'cervus-success__line';
        paragraph.textContent = line;
        textBody.appendChild(paragraph);
      });

      const meta = document.createElement('p');
      meta.className = 'cervus-success__line cervus-success__meta';
      meta.textContent = successCopy.meta;
      textBody.appendChild(meta);

      banner.dataset.cervusSuccessEnhanced = 'true';
      syncSuccessLayout();
      window.cervusFormScrollGuard?.hold?.(1800);
    }

    function bindSubmitScrollGuard(shadowRoot) {
      if (!shadowRoot || shadowRoot.dataset.cervusSubmitGuardBound === 'true') return;

      shadowRoot.addEventListener(
        'click',
        (event) => {
          const submitButton = event.target.closest('[data-testid="btn-form-submit"], button[type="submit"]');
          if (!submitButton || !panelRoot.classList.contains('is-open')) return;
          window.cervusFormScrollGuard?.hold?.(2500);
        },
        true
      );

      shadowRoot.dataset.cervusSubmitGuardBound = 'true';
    }

    function watchEmbed(embed) {
      if (!embed || watchedEmbeds.has(embed)) return;
      watchedEmbeds.add(embed);

      const observeShadow = () => {
        if (!embed.shadowRoot) return;

        bindSubmitScrollGuard(embed.shadowRoot);
        enhanceSuccessBanner(embed.shadowRoot);

        const observer = new MutationObserver(() => {
          bindSubmitScrollGuard(embed.shadowRoot);
          enhanceSuccessBanner(embed.shadowRoot);
          syncSuccessLayout();
          scheduleMobileFieldWidthSync();

          if (embed.shadowRoot.querySelector('[data-testid="banner-success"]')) {
            window.cervusFormScrollGuard?.hold?.(1800);
          }
        });

        observer.observe(embed.shadowRoot, { childList: true, subtree: true });
        scheduleMobileFieldWidthSync();
      };

      if (embed.shadowRoot) {
        observeShadow();
        return;
      }

      const hostObserver = new MutationObserver(() => {
        if (embed.shadowRoot) {
          hostObserver.disconnect();
          observeShadow();
        }
      });

      hostObserver.observe(embed, { childList: true });
    }

    function scanEmbeds() {
      panelRoot.querySelectorAll('shopify-forms-embed').forEach(watchEmbed);
      syncSuccessLayout();
      scheduleMobileFieldWidthSync();
    }

    scanEmbeds();

    const panelObserver = new MutationObserver(scanEmbeds);
    panelObserver.observe(panelRoot, { childList: true, subtree: true });

    const panelOpenObserver = new MutationObserver(() => {
      if (panelRoot.classList.contains('is-open')) {
        scheduleMobileFieldWidthSync();
      }
    });
    panelOpenObserver.observe(panelRoot, { attributes: true, attributeFilter: ['class'] });

    mobileFieldWidthQuery.addEventListener('change', scheduleMobileFieldWidthSync);
    window.addEventListener('resize', scheduleMobileFieldWidthSync, { passive: true });

    panelRoot.addEventListener(
      'focusin',
      () => {
        if (!panelRoot.classList.contains('is-open')) return;
        window.cervusFormScrollGuard?.hold?.(600);
      },
      true
    );

    panelRoot.addEventListener('click', (event) => {
      if (event.target.closest('[data-contact-close]')) {
        window.setTimeout(syncSuccessLayout, 0);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        window.setTimeout(syncSuccessLayout, 0);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["home-editorial-split"] && !Shopify.designMode) return;
  try {
    (function () {
    if (!document.body.classList.contains('template-index')) return;
    if (window.__cervusHomeSplitHeightSyncInit) return;
    window.__cervusHomeSplitHeightSyncInit = true;

    const SPLIT_SELECTOR =
      '.section-home-ritual-product .home-editorial-split, .section-home-featured-product .home-editorial-split, .section-editorial-universe .home-editorial-split';
    const GRID_SELECTOR =
      '.section-home-ritual-product .home-editorial-split__grid, .section-home-featured-product .home-editorial-split__grid, .section-editorial-universe .home-editorial-split__grid';

    const clearSync = () => {
      document.body.classList.remove('is-home-split-height-synced');
      document.body.style.removeProperty('--home-split-shared-min-height');
      document.body.style.removeProperty('--home-split-shared-content-height');
      document.body.style.removeProperty('--home-split-shared-media-height');
    };

    const MOBILE_MQ = window.matchMedia('(max-width: 47.99rem)');

    const measureGrid = (grid) => {
      const content = grid.querySelector('.home-editorial-split__content');
      const media = grid.querySelector('.home-editorial-split__media');
      return {
        grid: grid.getBoundingClientRect().height,
        content: content ? content.getBoundingClientRect().height : 0,
        media: media ? media.getBoundingClientRect().height : 0,
      };
    };

    const syncHomeSplitHeights = () => {
      const grids = Array.from(document.querySelectorAll(GRID_SELECTOR));
      if (!grids.length) return;

      clearSync();

      grids.forEach((grid) => {
        grid.style.removeProperty('height');
        grid.style.removeProperty('max-height');
        grid.style.removeProperty('min-height');
      });

      let maxGrid = 0;
      let maxContent = 0;
      let maxMedia = 0;

      if (MOBILE_MQ.matches) {
        const referenceGrid = document.querySelector('.section-home-ritual-product .home-editorial-split__grid');
        if (referenceGrid) {
          const reference = measureGrid(referenceGrid);
          maxGrid = reference.grid;
          maxContent = reference.content;
          maxMedia = reference.media;
        }
      } else {
        grids.forEach((grid) => {
          const measured = measureGrid(grid);
          maxGrid = Math.max(maxGrid, measured.grid);
          maxContent = Math.max(maxContent, measured.content);
          maxMedia = Math.max(maxMedia, measured.media);
        });
      }

      if (!maxGrid) return;

      document.body.style.setProperty('--home-split-shared-min-height', `${maxGrid}px`);
      document.body.style.setProperty('--home-split-shared-content-height', `${maxContent}px`);
      document.body.style.setProperty('--home-split-shared-media-height', `${maxMedia}px`);
      document.body.classList.add('is-home-split-height-synced');
    };

    const init = () => {
      const splits = document.querySelectorAll(SPLIT_SELECTOR);
      if (!splits.length) return;

      syncHomeSplitHeights();

      if (typeof ResizeObserver !== 'undefined') {
        const observer = new ResizeObserver(syncHomeSplitHeights);
        splits.forEach((split) => observer.observe(split));
      }

      window.addEventListener('resize', syncHomeSplitHeights, { passive: true });
      if (typeof MOBILE_MQ.addEventListener === 'function') {
        MOBILE_MQ.addEventListener('change', syncHomeSplitHeights);
      } else if (typeof MOBILE_MQ.addListener === 'function') {
        MOBILE_MQ.addListener(syncHomeSplitHeights);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lifestyle-archive-home"] && !Shopify.designMode) return;
  try {
    (function () {
    const root = document.querySelector('.lifestyle-archive-home');
    if (!root || root.dataset.recommendationsInit === 'true') return;
    root.dataset.recommendationsInit = 'true';

    const viewport = root.querySelector('[data-recommendations-viewport]');
    const track = root.querySelector('[data-recommendations-track]');
    const prevButton = root.querySelector('[data-recommendations-prev]');
    const nextButton = root.querySelector('[data-recommendations-next]');
    const primaryGroup = track?.querySelector('.botica-recommendations__group:not([aria-hidden])');

    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobileQuery = window.matchMedia('(max-width: 47.99rem)');
    let prefersReducedMotion = motionQuery.matches;

    const AUTO_INTERVAL_MS = 3000;
    const PAUSE_AFTER_INTERACTION_MS = 6000;
    const PAUSE_AFTER_INTERACTION_MOBILE_MS = 2500;
    const TRANSITION_DURATION_MS = 220;
    const TRANSITION_EASING = 'ease-out';
    const DRAG_THRESHOLD_PX = 8;
    const DRAG_THRESHOLD_MOBILE_PX = 4;

    let offset = 0;
    let loopWidth = 0;
    let stepWidth = 0;
    let isPaused = false;
    let isHovered = false;
    let isDragging = false;
    let isAnimating = false;
    let pauseTimer = null;
    let autoTimer = null;
    let animationTimer = null;
    let transitionEndHandler = null;
    let activePointer = null;
    let pointerStartX = 0;
    let pointerStartOffset = 0;
    let pointerStartY = 0;
    let dragDistance = 0;
    let dragActivated = false;
    let isTouching = false;
    let dragRaf = null;
    let pendingDragDeltaX = 0;
    let prependGroup = null;
    let lastPointerX = 0;
    let lastPointerTime = 0;
    let dragVelocity = 0;
    let momentumRaf = null;

    function isMobileHomeCarousel() {
      return document.body.classList.contains('template-index') && mobileQuery.matches;
    }

    function isDesktopHomeCarousel() {
      return document.body.classList.contains('template-index') && !mobileQuery.matches;
    }

    function getPrimaryCards() {
      return primaryGroup ? [...primaryGroup.querySelectorAll('[data-lifestyle-carousel-item]')] : [];
    }

    function ensureNavEnabled() {
      if (!prevButton || !nextButton) return;
      prevButton.disabled = false;
      nextButton.disabled = false;
      prevButton.removeAttribute('aria-disabled');
      nextButton.removeAttribute('aria-disabled');
    }

    function mobileLoopActive() {
      return isMobileHomeCarousel() && track?.dataset.mobileLoopReady === 'true';
    }

    function dragThresholdPx() {
      return isMobileHomeCarousel() ? DRAG_THRESHOLD_MOBILE_PX : DRAG_THRESHOLD_PX;
    }

    function setupMobileLoopTrack() {
      if (!isMobileHomeCarousel() || !track || !primaryGroup) return;
      if (track.dataset.mobileLoopReady === 'true') return;

      prependGroup = primaryGroup.cloneNode(true);
      prependGroup.setAttribute('aria-hidden', 'true');
      prependGroup.querySelectorAll('[id]').forEach((element) => {
        element.removeAttribute('id');
      });
      track.insertBefore(prependGroup, primaryGroup);
      track.dataset.mobileLoopReady = 'true';
    }

    function teardownMobileLoopTrack() {
      if (!track || track.dataset.mobileLoopReady !== 'true') return;

      prependGroup?.remove();
      prependGroup = null;
      delete track.dataset.mobileLoopReady;
    }

    function cancelMomentum() {
      if (momentumRaf === null) return;
      window.cancelAnimationFrame(momentumRaf);
      momentumRaf = null;
    }

    function applyDragOffset(deltaX) {
      clearTrackTransition();
      offset = pointerStartOffset + deltaX;
      normalizeOffset(true);
      applyTransform(false);
    }

    function scheduleDragOffset(deltaX) {
      pendingDragDeltaX = deltaX;

      if (dragRaf !== null) return;

      dragRaf = window.requestAnimationFrame(() => {
        dragRaf = null;
        applyDragOffset(pendingDragDeltaX);
      });
    }

    function cancelScheduledDrag() {
      if (dragRaf === null) return;
      window.cancelAnimationFrame(dragRaf);
      dragRaf = null;
    }

    function snapAndAnimateRelease() {
      snapToNearestStep();
      normalizeOffset();

      if (!prefersReducedMotion) {
        animateOffset(offset);
      } else {
        applyTransform(false);
      }

      isTouching = false;
      pauseAuto();
      resetAutoAdvance();
    }

    function runMomentum(initialVelocity) {
      cancelMomentum();

      let velocity = initialVelocity;

      function momentumFrame() {
        if (Math.abs(velocity) < 0.35) {
          momentumRaf = null;
          snapAndAnimateRelease();
          return;
        }

        clearTrackTransition();
        offset += velocity;
        velocity *= 0.92;
        normalizeOffset();
        applyTransform(false);
        momentumRaf = window.requestAnimationFrame(momentumFrame);
      }

      momentumRaf = window.requestAnimationFrame(momentumFrame);
    }

    function canUseTransformCarousel() {
      return !prefersReducedMotion;
    }

    function disableTransformCarousel() {
      if (!track || !viewport) return;

      clearInterval(autoTimer);
      clearTimeout(pauseTimer);
      cancelScheduledDrag();
      cancelMomentum();
      teardownMobileLoopTrack();
      cancelAnimationInstant();
      track.style.transform = 'none';
      track.style.transition = 'none';
      isDragging = false;
      isAnimating = false;
      isPaused = false;
      isTouching = false;
      activePointer = null;
      dragActivated = false;
      viewport.classList.remove('is-dragging');
    }

    function enableTransformCarousel() {
      const hadMobileLoop = mobileLoopActive();

      if (isMobileHomeCarousel()) {
        setupMobileLoopTrack();
      } else {
        teardownMobileLoopTrack();
      }

      measureCarousel();

      if (mobileLoopActive() && !hadMobileLoop) {
        offset = -loopWidth;
      } else if (isDesktopHomeCarousel()) {
        offset = 0;
      }

      normalizeOffset();
      applyTransform(false);
      ensureNavEnabled();
      startAutoAdvance();
    }

    function parseGap(styles) {
      const raw = styles.columnGap !== 'normal' ? styles.columnGap : styles.gap;
      if (!raw || raw === 'normal') return 0;
      const parsed = parseFloat(raw);
      return Number.isNaN(parsed) ? 0 : parsed;
    }

    function measureCarousel() {
      if (!primaryGroup || !track || !viewport) return;

      const cards = getPrimaryCards();
      const card = cards[0];
      if (!card) return;

      if (isMobileHomeCarousel()) {
        stepWidth = card.offsetWidth + parseGap(getComputedStyle(track));
        loopWidth = cards.length * stepWidth;
        return;
      }

      if (cards.length > 1) {
        stepWidth = cards[1].offsetLeft - cards[0].offsetLeft;
      } else {
        stepWidth = card.offsetWidth;
      }

      loopWidth = primaryGroup.offsetWidth + parseGap(getComputedStyle(track));
    }

    function normalizeOffset(adjustPointerStart = false) {
      ensureLoopMetrics();
      if (loopWidth <= 0) return;

      if (mobileLoopActive()) {
        while (offset <= -2 * loopWidth) {
          offset += loopWidth;
          if (adjustPointerStart) {
            pointerStartOffset += loopWidth;
          }
        }

        while (offset > 0) {
          offset -= loopWidth;
          if (adjustPointerStart) {
            pointerStartOffset -= loopWidth;
          }
        }

        return;
      }

      while (offset <= -loopWidth) {
        offset += loopWidth;
        if (adjustPointerStart) {
          pointerStartOffset += loopWidth;
        }
      }

      while (offset > 0) {
        offset -= loopWidth;
        if (adjustPointerStart) {
          pointerStartOffset -= loopWidth;
        }
      }
    }

    function snapToNearestStep() {
      if (!stepWidth) return;
      offset = Math.round(offset / stepWidth) * stepWidth;
    }

    function getCurrentOffset() {
      if (!track) return offset;

      const transform = window.getComputedStyle(track).transform;
      if (!transform || transform === 'none') return offset;

      return new DOMMatrixReadOnly(transform).m41;
    }

    function clearTrackTransition() {
      if (!track) return;
      track.style.transition = 'none';
    }

    function cancelAnimationInstant() {
      if (!track) return;

      clearTimeout(animationTimer);
      animationTimer = null;

      if (transitionEndHandler) {
        track.removeEventListener('transitionend', transitionEndHandler);
        transitionEndHandler = null;
      }

      clearTrackTransition();
      offset = getCurrentOffset();
      isAnimating = false;
      track.style.transform = `translate3d(${offset}px, 0, 0)`;
    }

    function bindTransitionEnd() {
      if (!track) return;

      transitionEndHandler = (event) => {
        if (event.target !== track || event.propertyName !== 'transform') return;
        finishAnimation();
      };

      track.addEventListener('transitionend', transitionEndHandler);
      animationTimer = window.setTimeout(finishAnimation, TRANSITION_DURATION_MS + 30);
    }

    function finishAnimation() {
      if (!track) return;

      clearTimeout(animationTimer);
      animationTimer = null;

      if (transitionEndHandler) {
        track.removeEventListener('transitionend', transitionEndHandler);
        transitionEndHandler = null;
      }

      clearTrackTransition();
      measureCarousel();
      normalizeOffset();
      applyTransform(false);
      isAnimating = false;
      ensureNavEnabled();
    }

    function applyTransform(animate = false) {
      if (!track) return;

      if (animate && !prefersReducedMotion) {
        track.style.transition = `transform ${TRANSITION_DURATION_MS}ms ${TRANSITION_EASING}`;
      } else {
        clearTrackTransition();
      }

      track.style.transform = `translate3d(${offset}px, 0, 0)`;
    }

    function pauseAuto(resume = true) {
      isPaused = true;
      clearTimeout(pauseTimer);

      if (resume && !prefersReducedMotion) {
        const pauseMs = isMobileHomeCarousel()
          ? PAUSE_AFTER_INTERACTION_MOBILE_MS
          : PAUSE_AFTER_INTERACTION_MS;

        pauseTimer = setTimeout(() => {
          isPaused = false;
        }, pauseMs);
      }
    }

    function startAutoAdvance() {
      clearInterval(autoTimer);

      if (!canUseTransformCarousel() || isMobileHomeCarousel()) return;

      autoTimer = setInterval(() => {
        if (isPaused || isHovered || isDragging || isAnimating || isTouching || momentumRaf !== null) return;
        stepCarousel(1, true);
      }, AUTO_INTERVAL_MS);
    }

    function resetAutoAdvance() {
      startAutoAdvance();
    }

    function animateOffset(targetOffset) {
      if (!track || prefersReducedMotion) {
        offset = targetOffset;
        normalizeOffset();
        applyTransform(false);
        return;
      }

      if (isAnimating) {
        cancelAnimationInstant();
      }

      offset = targetOffset;
      isAnimating = true;
      applyTransform(true);
      bindTransitionEnd();
    }

    function ensureLoopMetrics() {
      if (!loopWidth || !stepWidth || Number.isNaN(loopWidth) || Number.isNaN(stepWidth)) {
        measureCarousel();
      }
    }

    function prepareBackwardLoop() {
      measureCarousel();

      if (loopWidth <= 0) {
        return;
      }

      if (stepWidth <= 0) {
        return;
      }

      if (offset > -stepWidth * 0.5) {
        clearTrackTransition();
        offset -= loopWidth;
        applyTransform(false);
      }
    }

    function stepCarousel(direction, fromAuto = false) {
      if (isDragging) return;

      if (fromAuto) {
        if (isPaused || isHovered || isAnimating || isTouching || momentumRaf !== null) return;
      } else {
        pauseAuto();
        resetAutoAdvance();
        if (isAnimating) {
          cancelAnimationInstant();
        }
      }

      measureCarousel();

      if (!stepWidth) {
        return;
      }

      if (direction === -1) {
        prepareBackwardLoop();
      }

      offset += direction * -stepWidth;

      if (prefersReducedMotion) {
        normalizeOffset();
        applyTransform(false);
        ensureNavEnabled();
        return;
      }

      isAnimating = true;
      applyTransform(true);
      bindTransitionEnd();
    }

    function initCarouselControls() {
      if (!viewport || !track || !primaryGroup) return;

      measureCarousel();

      if (canUseTransformCarousel()) {
        enableTransformCarousel();
      } else {
        disableTransformCarousel();
      }

      ensureNavEnabled();

      prevButton?.addEventListener('click', () => {
        if (!canUseTransformCarousel()) return;
        stepCarousel(-1);
      });

      nextButton?.addEventListener('click', () => {
        if (!canUseTransformCarousel()) return;
        stepCarousel(1);
      });

      root.addEventListener('mouseenter', () => {
        isHovered = true;
      });

      root.addEventListener('mouseleave', () => {
        isHovered = false;
      });

      viewport.addEventListener(
        'click',
        (event) => {
          if (!canUseTransformCarousel()) return;
          if (dragDistance > dragThresholdPx()) {
            event.preventDefault();
            event.stopPropagation();
          }
        },
        true
      );

      viewport.addEventListener('pointerdown', (event) => {
        if (!canUseTransformCarousel()) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;

        cancelScheduledDrag();
        cancelMomentum();

        if (isAnimating) {
          cancelAnimationInstant();
        }

        if (isMobileHomeCarousel() && event.pointerType !== 'mouse') {
          isTouching = true;
          clearInterval(autoTimer);
        }

        activePointer = event.pointerId;
        dragActivated = false;
        isDragging = false;
        dragDistance = 0;
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
        pointerStartOffset = getCurrentOffset();
        lastPointerX = event.clientX;
        lastPointerTime = performance.now();
        dragVelocity = 0;
        pauseAuto(false);
      });

      viewport.addEventListener(
        'pointermove',
        (event) => {
          if (!canUseTransformCarousel()) return;
          if (event.pointerId !== activePointer) return;

          const deltaX = event.clientX - pointerStartX;
          const deltaY = event.clientY - pointerStartY;
          dragDistance = Math.max(dragDistance, Math.abs(deltaX));
          const threshold = dragThresholdPx();

          if (!dragActivated && dragDistance > threshold) {
            if (Math.abs(deltaY) > Math.abs(deltaX)) {
              activePointer = null;
              isTouching = false;
              dragActivated = false;
              isDragging = false;
              pauseAuto();
              resetAutoAdvance();
              return;
            }

            dragActivated = true;
            isDragging = true;
            viewport.classList.add('is-dragging');
            viewport.setPointerCapture(event.pointerId);
          }

          if (!dragActivated) return;

          if (event.pointerType !== 'mouse') {
            event.preventDefault();
          }

          const now = performance.now();
          const elapsed = now - lastPointerTime;

          if (elapsed > 0) {
            dragVelocity = (event.clientX - lastPointerX) / elapsed;
          }

          lastPointerX = event.clientX;
          lastPointerTime = now;
          applyDragOffset(deltaX);
        },
        { passive: false }
      );

      function endDrag(event) {
        if (!canUseTransformCarousel()) return;
        if (event.pointerId !== undefined && activePointer !== null && event.pointerId !== activePointer) return;

        cancelScheduledDrag();

        const wasDragActivated = dragActivated && activePointer !== null;

        if (wasDragActivated) {
          isDragging = false;
          viewport.classList.remove('is-dragging');

          if (viewport.hasPointerCapture(event.pointerId)) {
            viewport.releasePointerCapture(event.pointerId);
          }

          applyDragOffset(event.clientX - pointerStartX);

          if (isMobileHomeCarousel() && Math.abs(dragVelocity) > 0.25) {
            activePointer = null;
            dragActivated = false;
            dragDistance = 0;
            runMomentum(dragVelocity * 16);
            return;
          }

          snapAndAnimateRelease();
        } else {
          isTouching = false;
          pauseAuto();
          resetAutoAdvance();
        }

        activePointer = null;
        dragActivated = false;
        dragDistance = 0;
      }

      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);

      viewport.addEventListener(
        'wheel',
        (event) => {
          if (!canUseTransformCarousel()) return;
          if (isAnimating || isDragging) return;
          if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;

          event.preventDefault();
          pauseAuto();
          clearTrackTransition();
          offset -= event.deltaX;
          snapToNearestStep();
          normalizeOffset();
          applyTransform(false);
          resetAutoAdvance();
        },
        { passive: false }
      );

      if (typeof ResizeObserver !== 'undefined') {
        const resizeObserver = new ResizeObserver(() => {
          if (!canUseTransformCarousel()) return;
          if (isDragging || isAnimating) return;
          measureCarousel();
          snapToNearestStep();
          normalizeOffset();
          applyTransform(false);
          ensureNavEnabled();
        });

        resizeObserver.observe(viewport);
        resizeObserver.observe(track);
      } else {
        window.addEventListener('resize', () => {
          if (!canUseTransformCarousel()) return;
          if (isDragging || isAnimating) return;
          measureCarousel();
          snapToNearestStep();
          normalizeOffset();
          applyTransform(false);
          ensureNavEnabled();
        });
      }

      motionQuery.addEventListener('change', () => {
        prefersReducedMotion = motionQuery.matches;

        if (canUseTransformCarousel()) {
          enableTransformCarousel();
        } else {
          disableTransformCarousel();
        }
      });

      mobileQuery.addEventListener('change', () => {
        if (!canUseTransformCarousel()) {
          disableTransformCarousel();
          return;
        }

        if (isDragging || isAnimating) {
          cancelAnimationInstant();
        }

        cancelMomentum();

        if (isMobileHomeCarousel()) {
          setupMobileLoopTrack();
        } else {
          teardownMobileLoopTrack();
        }

        measureCarousel();
        normalizeOffset();
        snapToNearestStep();
        normalizeOffset();
        applyTransform(false);
        ensureNavEnabled();
        startAutoAdvance();
      });
    }

    initCarouselControls();
  })();
  } catch(e) { console.error(e); }
})();

})();
